import axios from 'axios';
import { getToken } from './loginVerification';

export const saveCameraVisibility = async (hidden, hiddenUntil, message) => {
    const tokenData = await getToken();
    if (!tokenData.ok) {
        return { ok: false, message: 'Neprihlásený používateľ!' };
    }

    try {
        const instance = axios.create({
            headers: { 'Authorization': 'Bearer ' + tokenData.token }
        });
        const response = await instance.post(`${process.env.REACT_APP_API_HOST}/cameras/visibility`, {
            hidden: hidden,
            hiddenUntil: hiddenUntil,
            message: message
        });
        return response.data;
    } catch (error) {
        console.error('Error saving camera visibility:', error);
        return { ok: false, message: 'Chyba pri ukladaní nastavenia kamery' };
    }
};
